import styled from "styled-components";
import { COLORS } from "screens/perfilAutonomo/utils";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 20px;
  overflow-y: overlay;
  max-height: 70vh;

  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export const Row = styled.div<{ template: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template};
  grid-gap: 20px;
  align-items: center;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;

  p {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.gray400};
    line-height: 21px;
  }

  span {
    font-size: 14px;
    color: red !important;
  }

  strong {
    font-weight: 700;
  }

  .uploaded {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 40px;
    max-width: 200px;

    .remove {
      color: ${COLORS.error500};
      border-radius: 12px;
      padding: 6px;
      cursor: pointer;

      :hover {
        background-color: ${COLORS.error100};
      }
    }
  }
`;

export const FileHub = styled.div<{ isError?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: transparent;
  border: 1px solid ${({ isError }) => (isError ? COLORS.error500 : "#d0d5dd")};

  .icon {
    color: ${COLORS.info500};
    background-color: ${COLORS.info100};
    border-radius: 50%;
    padding: 6px;
    cursor: pointer;

    :hover {
      background-color: ${COLORS.info200};
    }
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLORS.gray200};
`;

export const FilesUpload = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const Buttons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  width: 100%;
`;
